module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "deals-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-storekeepers-freights",
      "md-label": "Грузы",
      "to": {
        name: 'StorekeepersFreights'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-storekeepers-itineraries",
      "md-label": "Маршрутные листы",
      "to": {
        name: 'StorekeepersItineraries'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1e89cce","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/storekeepers-menu.vue
// module id = 1233
// module chunks = 0